module.exports = __webpack_public_path__ + "img/22.0f2efc43.png";